import * as React from 'react';
import './StressBarometerAdminPanel.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import StressBarometerService from '../../../../services/StressBarometerService';
import AdminService from '../../../../services/AdminService';
import { IUser } from '../../../../interfaces/IUser';
import UserSearchPopup from '../../../userSearchPopup/UserSearchPopup';
import PushService from '../../../../services/PushService';
import NotificationService from '../../../../services/NotificationService';

export interface IProps {
  appStore?: AppStore;
  id?: string;
  reload: () => void;
}

export interface IState {
  searchValueUsers?: string;
  loadingUsers?: boolean;
  usersToRender?: JSX.Element[];
  user?: IUser;
  pushSend?: boolean;
}

@inject('appStore')
@observer
export default class StressBarometerAdminPanel extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (this.props.appStore!.stressBarometerToEdit?.userId) {
      this.getUser();
    }
  }

  getUser(): void {
    AdminService.getUserNameFromId(this.props.appStore!.stressBarometerToEdit.userId).then((user: IUser) => {
      this.setState({ user });
    });
  }

  render() {
    return (
      <div>
        <div
          className="stressBarometerPanelWrapper"
          style={{
            visibility: this.props.appStore!.stressBarometerToEdit != undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            this.props.appStore!.stressBarometerToEdit = undefined;
          }}
        />
        <div
          className="stressBarometerPanel"
          style={{
            right: this.props.appStore!.stressBarometerToEdit != undefined ? 0 : -620
          }}
        >
          <div className="editPanelCloseBtn"
            onClick={() => {
              this.props.appStore!.stressBarometerToEdit = undefined;
              this.props.reload();
            }}
          />
          <h3>{this.props.appStore!.stressBarometerToEdit?.objectId ? window.loc.strings.editStressBarometer : window.loc.strings.createStressBarometer}</h3>
          <div className="inputFieldLabel">{window.loc.strings.stressBarometerHeadline}</div>
          <input
            type="text"
            value={this.props.appStore!.stressBarometerToEdit?.title}
            onChange={(event: any) => {
              this.props.appStore!.stressBarometerToEdit.title = event.target.value;
              this.props.appStore!.stressBarometerToEdit = { ...this.props.appStore!.stressBarometerToEdit };
            }}
          />
          <div className="inputFieldLabel">{window.loc.strings.stressBarometerAreas}</div>
          {this.props.appStore!.stressBarometerToEdit?.areas?.map((area, index) => (
            <div key={index} className="roadmapQuestion">
              <input
                type="text"
                value={area.title}
                onChange={(event: any) => {
                  this.props.appStore!.stressBarometerToEdit.areas[index].title = event.target.value;
                  this.props.appStore!.stressBarometerToEdit = { ...this.props.appStore!.stressBarometerToEdit };
                }}
              />
            </div>
          ))}
          <div className="inputFieldLabel">{window.loc.strings.userEmail}</div>
          {this.props.appStore!.stressBarometerToEdit?.userId && this.state.user ?
            <div
              key={"userId_" + this.props.appStore!.stressBarometerToEdit?.userId}
              className="emailLabel"
            >
              {this.state.user?.name}
              <div
                className="emailLabelDeleteBtn"
                onClick={() => {
                  this.props.appStore!.stressBarometerToEdit.userId = undefined;
                }}
              />
            </div>
            :
            <>
              <input
                type="text"
                placeholder={window.loc.strings.searchForUsers}
                value={this.state.searchValueUsers}
                style={{
                  width: "100%"
                }}
                onChange={(event: any) => {
                  this.setState({ searchValueUsers: event.target.value.toLowerCase() });
                }}
              />
              <div
                className="searchButton"
                onClick={() => {
                  const usersToRender = [];
                  this.setState({ loadingUsers: true });
                  AdminService.getUsers(this.state.searchValueUsers).then((users: IUser[]) => {
                    if (users && users.length > 0) {
                      users.forEach(async (user: IUser) => {
                        usersToRender.push(
                          <div
                            className='emailLabel'
                            onClick={() => {
                              this.props.appStore!.stressBarometerToEdit.userId = user.id;
                              this.setState({
                                usersToRender: [],
                                searchValueUsers: undefined
                              });
                              this.getUser();
                            }}
                          >
                            {`${user.name} (${user.username})`}
                          </div>
                        );
                      });
                      this.setState({ usersToRender, loadingUsers: false });
                    } else {
                      this.setState({ loadingUsers: false });
                    }
                  });
                }}
              />
              <div style={{
                width: "100%",
                float: "left",
                clear: "both"
              }}>
                <div className="inputFieldLabel">{window.loc.strings.allowUserToEditAreas}</div>
                <label className={"IA_switchLabel"}>
                  <div
                    style={{
                      position: "relative",
                    }}
                    className="IA_OnFocus"
                    tabIndex={0}
                    role="switch"
                  >
                    <input
                      type="checkbox"
                      tabIndex={-1}
                      checked={this.props.appStore!.stressBarometerToEdit?.allowUserToEditAreas ? true : false}
                      onChange={() => {
                        this.props.appStore!.stressBarometerToEdit.allowUserToEditAreas = !this.props.appStore!.stressBarometerToEdit?.allowUserToEditAreas;
                        this.props.appStore!.stressBarometerToEdit = { ...this.props.appStore!.stressBarometerToEdit };
                      }}
                    />
                    <span
                      tabIndex={-1}
                      className={"IA_switchSlider"}
                      style={{
                        boxShadow: this.props.appStore!.stressBarometerToEdit?.allowUserToEditAreas ? `0 0 1px #7a12d4` : "none",
                        background: this.props.appStore!.stressBarometerToEdit?.allowUserToEditAreas ? "#7a12d4" : "#3c3c3c"
                      }}
                    ></span>
                  </div>
                </label>
              </div>
            </>
          }
          <div
            className='newStressBarometerButton'
            style={{
              clear: "both",
              float: "left",
              marginTop: "20px",
              backgroundColor: "#7a12d4",
              color: "white",
            }}
            onClick={() => {
              if (this.props.appStore!.stressBarometerToEdit?.userId) {
                if (!this.props.appStore!.stressBarometerToEdit.objectId) {
                  StressBarometerService.createStressBarometer(this.props.appStore!.stressBarometerToEdit).then((objectId: string) => {
                    if (this.state.user?.username) {
                      const notification = {
                        title: window.loc.strings.stressBarometerInvitationHeading,
                        text: window.loc.strings.stressBarometerInvitationContent.replace("xxx", this.state.user?.name),
                        link: `https://dojo.mindjuice.com/?stressbarometerid=${objectId}`,
                        linkText: window.loc.strings.stressBarometerInvitationLinkText,
                        sendToAll: false,
                        receivers: [this.state.user?.username],
                      };
                      NotificationService.createNotification(notification).then(() => {
                        PushService.sendPush({
                          "app_id": "928ff6d5-5b5f-437b-a4c8-4a6dfcdb35e2",
                          "include_external_user_ids": notification.receivers,
                          "content_available": 1,
                          "headings": {
                            "en": notification.title
                          },
                          "contents": {
                            "en": notification.text
                          },
                          "name": "INTERNAL_CAMPAIGN_NAME",
                          "data": {
                            "url": notification.link,
                            "linkText": notification.linkText
                          }
                        }).then(() => {
                          this.setState({
                            pushSend: true
                          });
                        });
                      })
                    }
                  });
                } else {
                  StressBarometerService.updateStressBarometer(this.props.appStore!.stressBarometerToEdit).then(() => {
                    this.props.appStore!.stressBarometerToEdit = undefined;
                    this.props.reload();
                  });
                }
              }
            }}
          >
            {window.loc.strings.save}
          </div>
          {this.state.pushSend &&
            <div style={{
              marginTop: "20px",
              width: "auto",
              float: "left",
              clear: "both",
              border: "1px solid #ffffff",
              borderRadius: "5px",
              padding: "10px",
            }}>
              {window.loc.strings.stressBarometerInvitationSent.replace("xxx", this.state.user?.name)}
            </div>
          }
          {this.props.appStore!.stressBarometerToEdit?.objectId &&
            <>
              <div className="inputFieldLabel">{window.loc.strings.stressBarometerLink}</div>
              <div className='stressBarometerLink'>{`https://dojo.mindjuice.com/?stressbarometerid=${this.props.appStore!.stressBarometerToEdit.objectId}`}</div>
            </>
          }
        </div>
        {
          this.state.usersToRender?.length > 0 &&
          <UserSearchPopup
            users={this.state.usersToRender}
            close={() => {
              this.setState({
                usersToRender: [],
                searchValueUsers: undefined,
              }, () => this.forceUpdate());
            }}
          />
        }
      </div >
    );
  }
}